import React from 'react';
import './App.css';
import Container from '@mui/material/Container';
import {createTheme, ThemeProvider} from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import Footer from "./components/Footer";
import Home from "./pages/Home"
import Contact from "./pages/Contact"
import About from "./pages/About"
import Links from "./pages/Links";
import CookiePopup from "./components/CookiePopup";
import Book from "./pages/Book";


const theme = createTheme();

const sections = [{title: 'Home', url: '/'}, {title: 'About', url: '/about'},  {title: 'Contact', url: '/contact'},
    {title: 'Book Now', 'url': '/book'}, {title: 'Links and Resources', url: '/links'}];

export default function App() {
    return (
        <div className='App'>
            <ThemeProvider theme={theme}>
                <CssBaseline/>
                <Container maxWidth="lg">
                    <main>
                        <Router>
                            <Routes>
                                <Route exact path='/' element={<Home sections={sections}/>}/>
                                <Route exact path='/home' element={<Home sections={sections}/>}/>
                                <Route exact path='/about' element={<About sections={sections}/>}/>
                                <Route exact path='/contact' element={<Contact sections={sections}/>}/>
                                <Route exact path='/book' element={<Book sections={sections}/>}/>
                                <Route exact path='/links' element={<Links sections={sections}/>}/>
                                <Route path='*' element={<Home sections={sections}/>}/>
                            </Routes>
                        </Router>
                    </main>
                    <Footer/>
                </Container>
            </ThemeProvider>
            <CookiePopup/>

        </div>
    );
}
